import styled from 'styled-components';
import { RowStyled } from '../RowStyled';

export const RowStyledAC = styled(RowStyled)``;
